<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="seasonName" id="seasonName" type="text" pInputText>
            <label for="seasonName">Season Name</label>
            @for (validation of validationMessages.seasonName; track validation) {
              <span>
                @if (form1.get('seasonName').hasError(validation.type) && (form1.get('seasonName').dirty || form1.get('seasonName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-calendar formControlName="seasonStart" [dataType]="'string'" [required]="true" inputId="seasonStart" >
            </p-calendar>
            <label for="seasonStart">Season Start</label>
            @for (validation of validationMessages.seasonStart; track validation) {
              <span>
                @if (form1.get('seasonStart').hasError(validation.type) && (form1.get('seasonStart').dirty || form1.get('seasonStart').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-calendar formControlName="seasonEnd" [dataType]="'string'" [required]="true" inputId="seasonEnd" >
            </p-calendar>
            <label for="seasonEnd">Season End</label>
            @for (validation of validationMessages.seasonEnd; track validation) {
              <span>
                @if (form1.get('seasonEnd').hasError(validation.type) && (form1.get('seasonEnd').dirty || form1.get('seasonEnd').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber  formControlName="targetRateAmt" [minFractionDigits]="0" (onBlur)="onTargetChange()" [required]="true" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="targetRateAmt">Target Rate</label>
            @for (validation of validationMessages.targetRateAmt; track validation) {
              <span>
                @if (form1.get('targetRateAmt').hasError(validation.type) && (form1.get('targetRateAmt').dirty || form1.get('targetRateAmt').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="targetOccupancyPct" id="targetOccupancyPct"
          mask="9.9?9"></p-inputMask>
          <label for="targetOccupancyPct">Target Occupancy Pct</label> -->
          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Target Occupancy Pct : <b>{{targetOccupancyPct.value*100 | number : '1.0-2'}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('targetOccupancyPct')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="0" max="1" step=".01"
                pTooltip="Range: 0 to 100 as decimal. Income low values in percentage"
                tooltipPosition="bottom">
                <input matSliderThumb #targetOccupancyPct formControlName="targetOccupancyPct">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('targetOccupancyPct')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            @if (invalidTargetOccupancyPct) {
              <span>
                <small class="p-invalid">Target Occupancy Pct can not be zero.</small>
              </span>
            }
          </div>
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <!-- <input formControlName="hightRateAmt" id="hightRateAmt" type="number"  pInputText> -->
          <p-inputNumber formControlName="hightRateAmt" [minFractionDigits]="0" [required]="true" inputId="currency-us" mode="currency" currency="USD" locale="en-US" (onBlur)="validateRateAmounts()">
          </p-inputNumber>
          <label for="hightRateAmt">High Rate</label>
          @for (validation of validationMessages.hightRateAmt; track validation) {
            <span>
              @if (form1.get('hightRateAmt').hasError(validation.type) && (form1.get('hightRateAmt').dirty || form1.get('hightRateAmt').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
          @if (invalidHighOccupancyAmt) {
            <span>
              <small class="p-invalid">High Rate must be greater than or equal to Target Rate and Low Rate.</small>
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <!-- <p-inputMask formControlName="highAdjPct" id="highAdjPct"
        mask="9.9?9"></p-inputMask>
        <label for="highAdjPct">HighAdj Pct</label> -->
        <div style="flex: 0 0 calc(100% - 30px)">
          <mat-label>HighAdj Pct : <b>{{highAdjPct.value*100 | number : '1.0-2'}}%</b></mat-label>
          <div>
            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('highAdjPct')">
              <i class="pi pi-minus"></i>
            </button>
            <mat-slider class="flex-1" min="0" max="1" step=".01"
              pTooltip="Range: 0 to 100 as decimal. Income high values in percentage"
              tooltipPosition="bottom">
              <input matSliderThumb #highAdjPct formControlName="highAdjPct">
            </mat-slider>
            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('highAdjPct')">
              <i class="pi pi-plus"></i>
            </button>
          </div>
          @if (invalidHighOccupancyPct) {
            <span>
              <small class="p-invalid">Target High Pct can not be zero or lower than target or low pct.</small>
            </span>
          }
        </div>
        @for (validation of validationMessages.highAdjPct; track validation) {
          <span>
            @if (form1.get('highAdjPct').hasError(validation.type) && (form1.get('highAdjPct').dirty || form1.get('highAdjPct').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <!-- <input formControlName="lowRateAmt" id="lowRateAmt" type="number" pInputText> -->
        <p-inputNumber formControlName="lowRateAmt" [minFractionDigits]="0" [required]="true" inputId="currency-us" mode="currency" currency="USD" locale="en-US" (onBlur)="validateRateAmounts()">
        </p-inputNumber>
        <label for="lowRateAmt">Low Rate</label>
        @for (validation of validationMessages.lowRateAmt; track validation) {
          <span>
            @if (form1.get('lowRateAmt').hasError(validation.type) && (form1.get('lowRateAmt').dirty || form1.get('lowRateAmt').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
        @if (invalidLowOccupancyAmt) {
          <span>
            <small class="p-invalid">Low Rate must be less than or equal to Target Rate and High Rate.</small>
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <!-- <p-inputMask formControlName="lowAdjPct" id="lowAdjPct"
      mask="9.9?9"></p-inputMask>
      <label for="lowAdjPct">LowAdj Pct</label> -->
      <div style="flex: 0 0 calc(100% - 30px)">
        <mat-label>LowAdj Pct : <b>{{lowAdjPct.value*100 | number : '1.0-2'}}%</b></mat-label>
        <div>
          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('lowAdjPct')">
            <i class="pi pi-minus"></i>
          </button>
          <mat-slider class="flex-1" min="0" max="1" step=".01"
            pTooltip="Range: 0 to 100 as decimal. Income low values in percentage"
            tooltipPosition="bottom">
            <input matSliderThumb #lowAdjPct formControlName="lowAdjPct">
          </mat-slider>
          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('lowAdjPct')">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        @if (invalidLowOccupancyPct) {
          <span>
            <small class="p-invalid">Target Low Pct can not be zero or higher than target or high pct.</small>
          </span>
        }
      </div>
      @for (validation of validationMessages.lowAdjPct; track validation) {
        <span>
          @if (form1.get('lowAdjPct').hasError(validation.type) && (form1.get('lowAdjPct').dirty || form1.get('lowAdjPct').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>


  <!--Proforma Parent ID Field here-->

  <!-- <div class="col-lg-6">
  <span class="p-float-label required-field w-100 mb-3">
    <p-dropdown [options]="proformaList" formControlName="proformaId" optionLabel="userId"
      optionValue="proformaId" [filter]="true" filterBy="userId" [showClear]="false"
      placeholder="Select Property Of Proforma">
    </p-dropdown>
    <label for="Select Property Of Proforma">Select Property Of Proforma</label>
    <span *ngFor="let validation of validationMessages.proformaId">
      <small class="p-invalid"
        *ngIf="form1.get('proformaId').hasError(validation.type) && (form1.get('proformaId').dirty || form1.get('proformaId').touched)">{{validation.message}}
      </small>
    </span>
  </span>
</div> -->

</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (proformaIncomeId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete ProformaIncome</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!proformaIncomeId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add ProformaIncome</button>
          }

          @if (proformaIncomeId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update ProformaIncome</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>